export var popularMakes = [
    {
        heading: "Popular makes",
        navItems: [
            {
                type: "link",
                label: "Ford",
                href: "/find-vehicle?make=ford"
            },
            {
                type: "link",
                label: "BMW",
                href: "/find-vehicle?make=bmw"
            },
            {
                type: "link",
                label: "Mercedes-Benz",
                href: "/find-vehicle?make=mercedes-benz"
            },
            {
                type: "link",
                label: "Volkswagen",
                href: "/find-vehicle?make=volkswagen"
            },
            {
                type: "link",
                label: "Audi",
                href: "/find-vehicle?make=audi"
            }, 
        ],
        sectionLink: "View all cars",
        href: "/find-vehicle"
    }, 
];
export var shopByBudget = [
    {
        heading: "Shop by budget",
        navItems: [
            {
                type: "link",
                label: "Cars under \xa37,500",
                href: "/find-vehicle?toPrice=7500"
            },
            {
                type: "link",
                label: "Cars under \xa310,000",
                href: "/find-vehicle?toPrice=10000"
            },
            {
                type: "link",
                label: "Cars under \xa315,000",
                href: "/find-vehicle?toPrice=15000"
            },
            {
                type: "link",
                label: "Cars under \xa320,000",
                href: "/find-vehicle?toPrice=20000"
            },
            {
                type: "link",
                label: "Cars over \xa320,000",
                href: "/find-vehicle?fromPrice=20000"
            }, 
        ]
    }, 
];
export var resourcesAndGuides = [
    {
        heading: "Resources and guides",
        navItems: [
            {
                type: "link",
                label: "Car reviews",
                href: "/reviews"
            },
            {
                type: "link",
                label: "Guides",
                href: "/guides"
            },
            {
                type: "link",
                label: "Electric cars",
                href: "/electric-cars"
            },
            {
                type: "link",
                label: "News",
                href: "/news"
            }, 
        ]
    }, 
];
export var shopByType = [
    {
        heading: "Shop by type",
        cards: [
            {
                type: "link",
                label: "SUV",
                href: "/find-vehicle?bodyType=suv",
                image: "https://a.storyblok.com/f/132543/552x256/912e1f312e/suv.webp",
                alt: "SUV car"
            },
            {
                type: "link",
                label: "Hatchback",
                href: "/find-vehicle?bodyType=hatchback",
                image: "https://a.storyblok.com/f/132543/552x256/3be1cb3f1e/hatchback.webp",
                alt: "Hatchback car"
            },
            {
                type: "link",
                label: "Estate",
                href: "/find-vehicle?bodyType=estate",
                image: "https://a.storyblok.com/f/132543/552x256/561aaacd12/estate.webp",
                alt: "Estate car"
            },
            {
                type: "link",
                label: "Electric",
                href: "/find-vehicle?fuelType=electric",
                image: "https://a.storyblok.com/f/132543/552x256/c4d58ac89f/electric.webp",
                alt: "Electric car"
            },
            {
                type: "link",
                label: "Saloon",
                href: "/find-vehicle?bodyType=saloon",
                image: "https://a.storyblok.com/f/132543/552x256/3a5b8d2854/saloon.webp",
                alt: "Saloon car"
            },
            {
                type: "link",
                label: "Coupe",
                href: "/find-vehicle?bodyType=coupe",
                image: "https://a.storyblok.com/f/132543/552x256/82135a63e5/coupe.webp",
                alt: "Coupe car"
            }, 
        ]
    }, 
];
export var navCard = {
    heading: "Help me choose",
    body: "Use our nifty tool and go from 1000s of cars to tailored top picks",
    image: "https://a.storyblok.com/f/132543/1280x740/99803728e7/help-me-choose-cars.webp",
    alt: "Help me choose cars",
    isImageFullWidth: true,
    sectionLink: "Help me choose",
    href: "/help-me-choose"
};
export var mobileNavCard = {
    heading: "Not sure where to start?",
    image: "https://a.storyblok.com/f/132543/1280x782/5fbb92e715/help-me-choose-mobile.webp",
    alt: "Help me choose cars",
    link: "Help me choose",
    href: "/help-me-choose"
};
